/**
 *  .d8b.  db    db d888888b  .d88b.   d888b  d88888b d8b   db d88888b d8888b.  .d8b.  d888888b d88888b d8888b.
 * d8' `8b 88    88 `~~88~~' .8P  Y8. 88' Y8b 88'     888o  88 88'     88  `8D d8' `8b `~~88~~' 88'     88  `8D
 * 88ooo88 88    88    88    88    88 88      88ooooo 88V8o 88 88ooooo 88oobY' 88ooo88    88    88ooooo 88   88
 * 88~~~88 88    88    88    88    88 88  ooo 88~~~~~ 88 V8o88 88~~~~~ 88`8b   88~~~88    88    88~~~~~ 88   88
 * 88   88 88b  d88    88    `8b  d8' 88. ~8~ 88.     88  V888 88.     88 `88. 88   88    88    88.     88  .8D
 * YP   YP ~Y8888P'    YP     `Y88P'   Y888P  Y88888P VP   V8P Y88888P 88   YD YP   YP    YP    Y88888P Y8888D'
 *
 * DO NOT EDIT
 * CHANGES WILL BE OVERWRITTEN
 * Thu, 27 Nov 2025 20:57:31 GMT
 */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
export type ApplicationInformation = {
  application: {
    id: string;
    borrowerId: string;
    loanAmount: number;
    status: string;
    reason: null;
    createdAt?: (string | undefined) | null;
    variables: {
      automated_fraud_check_complete?: (boolean | undefined) | null;
      amount_financed?: (number | undefined) | null;
      apr?: (number | undefined) | null;
      bank_account_verification_complete?: (boolean | undefined) | null;
      bank_account_verification_skipped?: (boolean | undefined) | null;
      bank_information_manual_review?: (boolean | undefined) | null;
      bank_or_income_documents_uploaded?: (boolean | undefined) | null;
      borrower_email: string;
      borrower_first_name: string;
      borrower_last_name: string;
      borrower_phone: string;
      borrower_state_or_province: string;
      borrower_city: string;
      borrower_street_address: string;
      borrower_zip_or_postal_code: string;
      branch_address?: (string | undefined) | null;
      branch_city?: (string | undefined) | null;
      branch_hours?: (string | undefined) | null;
      branch_name?: (string | undefined) | null;
      branch_number?: (string | undefined) | null;
      branch_phone?: (string | undefined) | null;
      branch_state?: (string | undefined) | null;
      branch_zip_code?: (string | undefined) | null;
      calculate_loan_complete?: (boolean | undefined) | null;
      calculate_loan_complete_date?: (string | undefined) | null;
      child_support_or_alimony_income?: (boolean | undefined) | null;
      consumer_reports_consent_complete?: (boolean | undefined) | null;
      ecoa_consent_option_1_complete?: (boolean | undefined) | null;
      ecoa_consent_option_2_complete?: (boolean | undefined) | null;
      employee_salary_or_wages_income?: (boolean | undefined) | null;
      employer_name?: (string | undefined) | null;
      equifax_fico_score?: (number | undefined) | null;
      final_credit_underwriting_complete_date?: (string | undefined) | null;
      funding_complete?: (boolean | undefined) | null;
      funding_complete_date?: (string | undefined) | null;
      government_benefits_income?: (boolean | undefined) | null;
      income_sources_selected?: (boolean | undefined) | null;
      income_verification_complete?: (boolean | undefined) | null;
      last_4_digits_of_bank_account_number?: (string | undefined) | null;
      manual_review_required?: (boolean | undefined) | null;
      monthly_payment?: (number | undefined) | null;
      number_of_payments?: (number | undefined) | null;
      rental_property_income?: (boolean | undefined) | null;
      self_employed_income?: (boolean | undefined) | null;
      signing_document_complete?: (boolean | undefined) | null;
      sms_documents_upload_start_time?: (string | undefined) | null;
      sms_documents_uploaded?: (boolean | undefined) | null;
      sms_no_documents_uploaded_for_30_minutes?: (boolean | undefined) | null;
      submit_application_complete?: (boolean | undefined) | null;
      final_online_offer_status?: (string | undefined) | null;
      final_online_offer_loan_amount?: (number | undefined) | null;
      final_online_offer_rate?: (number | undefined) | null;
      final_online_offer_funded_term?: (number | undefined) | null;
      final_online_offer_estimated_payment?: (number | undefined) | null;
      online_offer_available?: (boolean | undefined) | null;
      finance_charge?: (number | undefined) | null;
      loan_balance?: (number | undefined) | null;
      first_payment_date?: (string | undefined) | null;
      first_payment_amount?: (number | undefined) | null;
      surcharge?: (number | undefined) | null;
      points?: (number | undefined) | null;
      total_other_charges?: (number | undefined) | null;
      loan_origination_fee?: (number | undefined) | null;
      ms_closing_fee?: (number | undefined) | null;
      prepaid_fees?: (number | undefined) | null;
      docstamptax77?: (number | undefined) | null;
      administrative_fee?: (number | undefined) | null;
      prequal_offer_loan_amount?: (number | undefined) | null;
      prequal_offer_estimated_payment?: (number | undefined) | null;
      ownership_match_code?: (number | undefined) | null;
    };
  };
};
export type BorrowerInformation = {
  borrower: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    activeApplication?:
      | (
          | {
              id: string;
              borrowerId: string;
              loanAmount: number;
              status: string;
              reason: null;
              createdAt?: (string | undefined) | null;
              variables: {
                automated_fraud_check_complete?: (boolean | undefined) | null;
                amount_financed?: (number | undefined) | null;
                apr?: (number | undefined) | null;
                bank_account_verification_complete?: (boolean | undefined) | null;
                bank_account_verification_skipped?: (boolean | undefined) | null;
                bank_information_manual_review?: (boolean | undefined) | null;
                bank_or_income_documents_uploaded?: (boolean | undefined) | null;
                borrower_email: string;
                borrower_first_name: string;
                borrower_last_name: string;
                borrower_phone: string;
                borrower_state_or_province: string;
                borrower_city: string;
                borrower_street_address: string;
                borrower_zip_or_postal_code: string;
                branch_address?: (string | undefined) | null;
                branch_city?: (string | undefined) | null;
                branch_hours?: (string | undefined) | null;
                branch_name?: (string | undefined) | null;
                branch_number?: (string | undefined) | null;
                branch_phone?: (string | undefined) | null;
                branch_state?: (string | undefined) | null;
                branch_zip_code?: (string | undefined) | null;
                calculate_loan_complete?: (boolean | undefined) | null;
                calculate_loan_complete_date?: (string | undefined) | null;
                child_support_or_alimony_income?: (boolean | undefined) | null;
                consumer_reports_consent_complete?: (boolean | undefined) | null;
                ecoa_consent_option_1_complete?: (boolean | undefined) | null;
                ecoa_consent_option_2_complete?: (boolean | undefined) | null;
                employee_salary_or_wages_income?: (boolean | undefined) | null;
                employer_name?: (string | undefined) | null;
                equifax_fico_score?: (number | undefined) | null;
                final_credit_underwriting_complete_date?: (string | undefined) | null;
                funding_complete?: (boolean | undefined) | null;
                funding_complete_date?: (string | undefined) | null;
                government_benefits_income?: (boolean | undefined) | null;
                income_sources_selected?: (boolean | undefined) | null;
                income_verification_complete?: (boolean | undefined) | null;
                last_4_digits_of_bank_account_number?: (string | undefined) | null;
                manual_review_required?: (boolean | undefined) | null;
                monthly_payment?: (number | undefined) | null;
                number_of_payments?: (number | undefined) | null;
                rental_property_income?: (boolean | undefined) | null;
                self_employed_income?: (boolean | undefined) | null;
                signing_document_complete?: (boolean | undefined) | null;
                sms_documents_upload_start_time?: (string | undefined) | null;
                sms_documents_uploaded?: (boolean | undefined) | null;
                sms_no_documents_uploaded_for_30_minutes?: (boolean | undefined) | null;
                submit_application_complete?: (boolean | undefined) | null;
                final_online_offer_status?: (string | undefined) | null;
                final_online_offer_loan_amount?: (number | undefined) | null;
                final_online_offer_rate?: (number | undefined) | null;
                final_online_offer_funded_term?: (number | undefined) | null;
                final_online_offer_estimated_payment?: (number | undefined) | null;
                online_offer_available?: (boolean | undefined) | null;
                finance_charge?: (number | undefined) | null;
                loan_balance?: (number | undefined) | null;
                first_payment_date?: (string | undefined) | null;
                first_payment_amount?: (number | undefined) | null;
                surcharge?: (number | undefined) | null;
                points?: (number | undefined) | null;
                total_other_charges?: (number | undefined) | null;
                loan_origination_fee?: (number | undefined) | null;
                ms_closing_fee?: (number | undefined) | null;
                prepaid_fees?: (number | undefined) | null;
                docstamptax77?: (number | undefined) | null;
                administrative_fee?: (number | undefined) | null;
                prequal_offer_loan_amount?: (number | undefined) | null;
                prequal_offer_estimated_payment?: (number | undefined) | null;
                ownership_match_code?: (number | undefined) | null;
              };
            }
          | undefined
        )
      | null;
  };
};
export type AccountCreatePostResponseType = {
  oktaId?: (string | undefined) | null;
};
export type AccountSendVerificationCodePostResponseType = {
  success: boolean;
};
export type AccountVerifyCodePostResponseType = {
  valid: boolean;
};
export type ApplicationsApplicationidDocumentRequirementsGetResponseType = {
  requirements: string[];
};
export type CashflowGetResponseType = {
  sessionToken: string;
};
export type HellosigndocPostResponseType = {
  status: 'SIGNING_DOCUMENTS_COMPLETE' | 'ALREADY_SIGNED' | 'OLD_SIGNATURE' | 'NEW_SIGNATURE';
  signatureRequestId: string | null;
  signURL: string | null;
};
export type OffersBranchPostResponseType = {
  globalId?: (string | undefined) | null;
};
export type OffersOnlinePostResponseType = {
  oktaId?: (string | undefined) | null;
};
export type PrequalificationGetResponseType = {
  data: {
    applicationId: string;
    status: string;
    account: {
      created: boolean;
      verified: boolean;
      email: string;
      firstName: string;
      lastName: string;
    };
    offersData: {
      loanAmount: number;
      branchOffer: {
        rate: number;
        loanAmount: number;
        payment: number;
        term: number;
        available: boolean;
      };
      onlineOffer: {
        rate: number;
        loanAmount: number;
        payment: number;
        term: number;
        available: boolean;
      } | null;
      createdAt?: string | undefined;
    };
    applicationData: {
      state: string;
    };
  };
};
export type PrequalificationPostResponseType = {
  applicationId: string;
  borrowerId: string;
};
export function createCustomPortalApi(baseQuery: ReturnType<typeof fetchBaseQuery>) {
  return createApi({
    reducerPath: 'customPortalApi',
    baseQuery: baseQuery,
    tagTypes: [
      'AccountCreatePostResponseType',
      'AccountSendVerificationCodePostResponseType',
      'AccountVerifyCodePostResponseType',
      'ApplicationInformation',
      'ApplicationsApplicationidDocumentRequirementsGetResponseType',
      'BorrowerInformation',
      'CashflowGetResponseType',
      'HellosigndocPostResponseType',
      'OffersBranchPostResponseType',
      'OffersOnlinePostResponseType',
      'PrequalificationGetResponseType',
      'PrequalificationPostResponseType',
    ],
    endpoints: (builder) => ({
      accountCreatePost: builder.mutation<
        AccountCreatePostResponseType,
        {
          body: {
            email: string;
            password: string;
            applicationId: string;
          };
        }
      >({
        query: ({ body }) => {
          return {
            url: '/account/create',
            method: 'POST',
            body: body,
          };
        },
        invalidatesTags: ['AccountCreatePostResponseType'],
      }),
      accountSendVerificationCodePost: builder.mutation<
        AccountSendVerificationCodePostResponseType,
        {
          body: {
            email: string;
          };
        }
      >({
        query: ({ body }) => {
          return {
            url: '/account/send-verification-code',
            method: 'POST',
            body: body,
          };
        },
        invalidatesTags: ['AccountSendVerificationCodePostResponseType'],
      }),
      accountVerifyCodePost: builder.mutation<
        AccountVerifyCodePostResponseType,
        {
          body: {
            code: string;
            applicationId: string;
          };
        }
      >({
        query: ({ body }) => {
          return {
            url: '/account/verify-code',
            method: 'POST',
            body: body,
          };
        },
        invalidatesTags: ['AccountVerifyCodePostResponseType'],
      }),
      applicationsApplicationidBankVerificationSkipPost: builder.mutation<
        ApplicationInformation,
        {
          params: {
            applicationId: string;
          };
        }
      >({
        query: ({ params }) => {
          return {
            url: '/applications/' + params.applicationId + '/bank-verification/skip',
            method: 'POST',
          };
        },
        invalidatesTags: ['ApplicationInformation'],
      }),
      applicationsApplicationidBankVerificationVerifyPost: builder.mutation<
        ApplicationInformation,
        {
          params: {
            applicationId: string;
          };
          body:
            | {
                inquiryType: 'BankVerify+';
                accountNumber: string;
                routingNumber: string;
                accountType: 'checking' | 'savings';
              }
            | {
                inquiryType: 'BankLogin+';
                accountTokenId: string;
                inquiryId: string;
              };
        }
      >({
        query: ({ params, body }) => {
          return {
            url: '/applications/' + params.applicationId + '/bank-verification/verify',
            method: 'POST',
            body: body,
          };
        },
        invalidatesTags: ['ApplicationInformation'],
      }),
      applicationsApplicationidBankVerificationReviewBankInformationManualyPost: builder.mutation<
        ApplicationInformation,
        {
          params: {
            applicationId: string;
          };
          body: {
            reviewBankInformationManually: boolean;
          };
        }
      >({
        query: ({ params, body }) => {
          return {
            url: '/applications/' + params.applicationId + '/bank-verification/review-bank-information-manualy',
            method: 'POST',
            body: body,
          };
        },
        invalidatesTags: ['ApplicationInformation'],
      }),
      applicationsApplicationidCompleteIncomeVerificationPost: builder.mutation<
        ApplicationInformation,
        {
          params: {
            applicationId: string;
          };
        }
      >({
        query: ({ params }) => {
          return {
            url: '/applications/' + params.applicationId + '/complete-income-verification',
            method: 'POST',
          };
        },
        invalidatesTags: ['ApplicationInformation'],
      }),
      applicationsApplicationidSaveEcoaConsentPost: builder.mutation<
        ApplicationInformation,
        {
          params: {
            applicationId: string;
          };
          body: {
            type: 'ecoa_consent_option_1_complete' | 'ecoa_consent_option_2_complete';
          };
        }
      >({
        query: ({ params, body }) => {
          return {
            url: '/applications/' + params.applicationId + '/save-ecoa-consent',
            method: 'POST',
            body: body,
          };
        },
        invalidatesTags: ['ApplicationInformation'],
      }),
      applicationsApplicationidSaveIncomeSourcesPost: builder.mutation<
        ApplicationInformation,
        {
          params: {
            applicationId: string;
          };
          body: {
            incomeSources: string[];
            employeeName?: string | undefined;
          };
        }
      >({
        query: ({ params, body }) => {
          return {
            url: '/applications/' + params.applicationId + '/save-income-sources',
            method: 'POST',
            body: body,
          };
        },
        invalidatesTags: ['ApplicationInformation'],
      }),
      applicationsApplicationidCalculateLoanPost: builder.mutation<
        ApplicationInformation,
        {
          params: {
            applicationId: string;
          };
        }
      >({
        query: ({ params }) => {
          return {
            url: '/applications/' + params.applicationId + '/calculate-loan',
            method: 'POST',
          };
        },
        invalidatesTags: ['ApplicationInformation'],
      }),
      applicationsApplicationidCompleteDocumentsSigningPost: builder.mutation<
        ApplicationInformation,
        {
          params: {
            applicationId: string;
          };
          body: {
            signatureRequestId: string;
          };
        }
      >({
        query: ({ params, body }) => {
          return {
            url: '/applications/' + params.applicationId + '/complete-documents-signing',
            method: 'POST',
            body: body,
          };
        },
        invalidatesTags: ['ApplicationInformation'],
      }),
      applicationsApplicationidCounterOfferAcceptPost: builder.mutation<
        ApplicationInformation,
        {
          params: {
            applicationId: string;
          };
        }
      >({
        query: ({ params }) => {
          return {
            url: '/applications/' + params.applicationId + '/counter-offer-accept',
            method: 'POST',
          };
        },
        invalidatesTags: ['ApplicationInformation'],
      }),
      applicationsApplicationidCounterOfferDeclinePost: builder.mutation<
        ApplicationInformation,
        {
          params: {
            applicationId: string;
          };
        }
      >({
        query: ({ params }) => {
          return {
            url: '/applications/' + params.applicationId + '/counter-offer-decline',
            method: 'POST',
          };
        },
        invalidatesTags: ['ApplicationInformation'],
      }),
      applicationsApplicationidDocumentRequirementsGet: builder.query<
        ApplicationsApplicationidDocumentRequirementsGetResponseType,
        {
          params: {
            applicationId: string;
          };
        }
      >({
        query: ({ params }) => {
          return {
            url: '/applications/' + params.applicationId + '/document-requirements',
            method: 'GET',
          };
        },
        providesTags: ['ApplicationsApplicationidDocumentRequirementsGetResponseType'],
      }),
      applicationsApplicationidGet: builder.query<
        ApplicationInformation,
        {
          params: {
            applicationId: string;
          };
        }
      >({
        query: ({ params }) => {
          return {
            url: '/applications/' + params.applicationId,
            method: 'GET',
          };
        },
        providesTags: ['ApplicationInformation'],
      }),
      applicationsApplicationidSubmitPost: builder.mutation<
        ApplicationInformation,
        {
          params: {
            applicationId: string;
          };
        }
      >({
        query: ({ params }) => {
          return {
            url: '/applications/' + params.applicationId + '/submit',
            method: 'POST',
          };
        },
        invalidatesTags: ['ApplicationInformation'],
      }),
      borrowerSearchPost: builder.mutation<
        BorrowerInformation,
        {
          body: {
            email: string;
          };
        }
      >({
        query: ({ body }) => {
          return {
            url: '/borrower/search',
            method: 'POST',
            body: body,
          };
        },
        invalidatesTags: ['BorrowerInformation'],
      }),
      cashflowGet: builder.query<
        CashflowGetResponseType,
        {
          params: {
            applicationId: string;
          };
          query: {
            firstName: string;
            lastName: string;
            emailAddress: string;
            phoneNumber: string;
            fullAmount: string;
            amount: string;
            streetAddress: string;
            city: string;
            zip: string;
            state: string;
          };
        }
      >({
        query: ({ params, query }) => {
          const queryString = '?' + new URLSearchParams(query);
          return {
            url: '/cashFlow' + queryString,
            method: 'GET',
          };
        },
        providesTags: ['CashflowGetResponseType'],
      }),
      hellosigndocPost: builder.mutation<
        HellosigndocPostResponseType,
        {
          body: {
            applicationId: string;
          };
        }
      >({
        query: ({ body }) => {
          return {
            url: '/hellosignDoc',
            method: 'POST',
            body: body,
          };
        },
        invalidatesTags: ['HellosigndocPostResponseType'],
      }),
      offersBranchPost: builder.mutation<
        OffersBranchPostResponseType,
        {
          body: {
            applicationId: string;
          };
        }
      >({
        query: ({ body }) => {
          return {
            url: '/offers/branch',
            method: 'POST',
            body: body,
          };
        },
        invalidatesTags: ['OffersBranchPostResponseType'],
      }),
      offersOnlinePost: builder.mutation<
        OffersOnlinePostResponseType,
        {
          body: {
            applicationId: string;
          };
        }
      >({
        query: ({ body }) => {
          return {
            url: '/offers/online',
            method: 'POST',
            body: body,
          };
        },
        invalidatesTags: ['OffersOnlinePostResponseType'],
      }),
      prequalificationGet: builder.query<
        PrequalificationGetResponseType,
        {
          query: {
            applicationId: string;
          };
        }
      >({
        query: ({ query }) => {
          const queryString = '?' + new URLSearchParams(query);
          return {
            url: '/preQualification' + queryString,
            method: 'GET',
          };
        },
        providesTags: ['PrequalificationGetResponseType'],
      }),
      prequalificationPost: builder.mutation<
        PrequalificationPostResponseType,
        {
          body: {
            request: {
              Prequal?: (string | null) | undefined;
              REPFIN_AppID: (string | null) | undefined;
              requested_amount: (string | null) | undefined;
              loan_purpose?: (string | null) | undefined;
              first_name?: (string | null) | undefined;
              last_name?: (string | null) | undefined;
              suffix_name?: (string | null) | undefined;
              home_street_address1?: (string | null) | undefined;
              home_street_address2?: (string | null) | undefined;
              home_city?: (string | null) | undefined;
              home_state?: (string | null) | undefined;
              home_zip_code: (string | null) | undefined;
              homephone: (string | null) | undefined;
              emailaddress: string;
              dob: (string | undefined) | null;
              input_ssn: string;
              MarketingContactConsent?: 'true' | 'false';
              PermissablePurpose?: 'true' | 'false';
              PrivacyNotice?: 'true' | 'false';
              EsignConsent?: 'true' | 'false';
              net_monthly_income: (string | undefined) | null;
              VerifiableIncome: (string | undefined) | null;
              Collateral?: 'true' | 'false';
              own_rent: '0' | '1';
              residence_payment: (string | undefined) | null;
              residence_months?: string;
              num_dependents: (string | undefined) | null;
              lead_gen_source?: (string | undefined) | null;
              ReferralSource?: (string | undefined) | null;
              phone_type?: (string | undefined) | null;
              employment_length?: string;
              employment_income?: string;
              customer_type?: (string | undefined) | null;
              additionalFraudCheck?: (('0' | '1') | undefined) | null;
              ChampChal_Flag?: (string | undefined) | null;
              FraudRulesTriggered_Flag?: (('0' | '1') | undefined) | null;
            };
            response: ({
              Customer_Tier_A1: (string | undefined) | null;
              system?:
                | (
                    | {
                        record_id?: (string | undefined) | null;
                      }
                    | undefined
                  )
                | null;
            } & (
              | {
                  Online_status: 'Declined';
                  Online_Rate?: (string | undefined) | null;
                  Online_EstimatedPayment?: (string | undefined) | null;
                  Online_Funded_term?: (string | undefined) | null;
                  Online_HighCreditLimit?: (string | undefined) | null;
                }
              | {
                  Online_status: 'Approved' | 'Counter Offer' | 'No Match';
                  Online_Rate: (string | undefined) | null;
                  Online_EstimatedPayment: (string | undefined) | null;
                  Online_Funded_term: (string | undefined) | null;
                  Online_HighCreditLimit: (string | undefined) | null;
                }
            )) &
              (
                | {
                    prequal_status: 'Declined';
                    Rate?: (string | undefined) | null;
                    EstimatedPayment: string | null;
                    Term?: (string | undefined) | null;
                    HighCreditLimit: string | null;
                  }
                | {
                    prequal_status: 'Approved' | 'Counter Offer' | 'No Match';
                    Rate: (string | undefined) | null;
                    EstimatedPayment: (string | undefined) | null;
                    Term: (string | undefined) | null;
                    HighCreditLimit: (string | undefined) | null;
                  }
              );
            globalId: (string | undefined) | null;
            verify_session_id: any;
            web_session_id?: any;
            transaction_id?: any;
            verify_ip_address?: any;
            branch_id?: any;
            branch_name?: (string | undefined) | null;
            branch_address?: (string | undefined) | null;
            branch_city?: (string | undefined) | null;
            branch_state?: (string | undefined) | null;
            branch_zip?: (string | undefined) | null;
            branch_phone?: (string | undefined) | null;
            branch_hours?: (string | undefined) | null;
          };
        }
      >({
        query: ({ body }) => {
          return {
            url: '/preQualification',
            method: 'POST',
            body: body,
          };
        },
        invalidatesTags: ['PrequalificationPostResponseType'],
      }),
    }),
  });
}
